<script>
import {useStore} from 'vuex'
import { onMounted } from 'vue'
import SubNavProfile from './SubNavProfile.vue'
import deepClone from 'foundation/js/deepClone'

export default {
    name: 'SubNavigationMobile',
    components: {SubNavProfile},
    props: {
        toggleMobileMenu :{
            type: Function,
            required: true
        },
        id: {
            type: String,
            required: true
        }
    },
    setup(props){
        const store = useStore()
        let first,last,close,originalTrigger

        const closeMobileMenu = (e) => {
            // Close the subnavigation burgermenu and overlay by invoking
            // the click event on the overlay before navigation to href
            document.querySelector('.kb-page-overlay--subnavigation').click()
            window.location.href = e.srcElement.href
        }

        
        const generalLink = store.state.main.sub_navigation_links?.generalLink?.href ? store.state.main.sub_navigation_links.generalLink : null
        const subLinks = store.state.main.sub_navigation_links.subLinks.map((link,index,list)=>{
            const clonedLink = deepClone(link)
            if(index === 0){
                clonedLink.order = "first"
            } else if (index === (list.length-1 && !generalLink)){
                clonedLink.order = "last"
            } else {
                clonedLink.order = index
            }
            return clonedLink
        })

        const tabTrap = function(e){      
            if(e.shiftKey && e.target.dataset.order === 'first'){
                e.preventDefault()
                close.focus()
            }

            if(e.shiftKey && e.target.dataset.order === 'close'){
                e.preventDefault()
                last.focus()
            }

            if(!e.shiftKey && e.target.dataset.order === 'last'){
                e.preventDefault()
                close.focus()
            }
            
            if(!e.shiftKey && !e.target.dataset.order){
                e.preventDefault()
                first.focus()
            }
        }

        onMounted(()=>{
            first = document.querySelector('.kb-sub-navigation__mobile-menu__link[data-order="first"]')
            last = document.querySelector('.kb-sub-navigation__mobile-menu__general-link[data-order="last"]')
            close = document.querySelector('.kb-sub-navigation__mobile-expand--close')
            originalTrigger = document.querySelector('.kb-sub-navigation__mobile-expand')

            first.focus()

            const escCloseHandler = (event)=>{
                if(event.key === 'Escape'){
                    props.toggleMobileMenu(originalTrigger)
                    document.body.removeEventListener('keydown',escCloseHandler)
                }
            }
            document.body.addEventListener('keydown',escCloseHandler)
        })

    return {
      links : {generalLink,subLinks},
      closeMobileMenu,
      tabTrap,
      originalTrigger
    }
  }
}
</script>

<template>
    <div 
        role="dialog"
        aria-modal="true"    
        class="kb-sub-navigation__mobile-menu kb-sub-navigation__mobile-menu--profile"
        :id="id"
    >
    <button
        v-on:click="toggleMobileMenu(originalTrigger)"
        v-on:keydown.tab="tabTrap"
        data-order="close"
        class="kb-sub-navigation__mobile-expand kb-sub-navigation__mobile-expand--close"
        aria-label="Luk menupunkter"
    >
        <span class="kb-sub-navigation__mobile-expand__icon" aria-hidden="true">
            <div class="kb-ui-icon kb-ui-icon--ui-close"></div>
        </span>
    </button>
        <ul>
            <template v-for="link,linkIndex in links.subLinks" :key="linkIndex">
                <li>
                    <a class="kb-sub-navigation__mobile-menu__link" v-on:click.prevent="closeMobileMenu" :href="link.href" v-on:keydown.tab="tabTrap" :aria-current="link.ariaCurrent" :data-order="link.order">
                        {{link.displayName}}
                        <svg class="kb-sub-navigation__mobile-menu__icon" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="presentation"><path d="m13.167 1 3.623 4-3.623 4" stroke="#3C3C3C" stroke-linejoin="round"/><path d="M12.746 5H1v3.692" stroke="#3C3C3C"/></svg>
                    </a>
                </li>
            </template>
        </ul>

        <sub-nav-profile :smallScreenMode="true"/>
        <a class="kb-sub-navigation__mobile-menu__general-link" :href="links.generalLink.href" v-on:keydown.tab="tabTrap" data-order="last">Gå til {{ links.generalLink.displayName }}</a>
    </div>

</template>
